import React from 'react';

interface ConditionalWrapperProps {
  condition: boolean;
  children: React.ReactNode;
  wrapper: React.FC;
}

export const ConditionalWrapper: React.FC<ConditionalWrapperProps> = ({
  condition,
  wrapper,
  children,
}) => (condition ? wrapper({ children }) : children) as React.ReactElement<any, any> | null;
